import moment from "moment"
import { first, join, map, trimEnd } from "lodash"

// name mapper functions
export function getParcelStatusName(type) {
  const MAP = {
    NEW: "NEW SHIPMENT CREATED",
    IN_DELIVERY: "DELIVERY PENDING / IN PROGRESS",
    EXCEPTION: "EXCEPTION",
    DELIVERED: "DELIVERED",
  }

  return MAP[type]
}

export function getParcelEventName(type) {
  const MAP = {
    PENDING: "Pending",
    INFO_RECEIVED: "Info Received",
    IN_TRANSIT: "In Transit for Delivery",
    OUT_FOR_DELIVERY: "Out For Delivery",
    ATTEMPT_FAIL: "Delivery Attempted - Failed",
    DELIVERED: "Delivered",
    EXCEPTION: "Exception",
    EXPIRED: "Expired",
  }

  return MAP[type]
}

// helper functions
export function createUrlForSeveralParcels(arr) {
  const url = map(arr, element => `id=${element.tracking_number || element}&`)
  const parcels = trimEnd(join(url, ""), "&")

  return `/parcels?${parcels}`
}

export function createUrlForSingleParcel(arr) {
  return `/parcel/${first(arr)}`
}

export function mapStatusToClass(status, styles) {
  switch (status) {
    case "DELIVERED":
      return styles.delivered
    case "DOMESTIC_TRANSIT":
      return styles.domesticTransit
    case "INTERNATIONAL_TRANSIT":
      return styles.internationalTransit
    case "RECEIVED_AT_HUB":
      return styles.atHub
    default:
      return ""
  }
}

export function getFormatedDate(timestamp) {
  const date = moment(timestamp * 1000)

  return {
    time: date.format("HH:mm:ss"),
    day: date.format("YYYY-MM-DD"),
  }
}



// WEBPACK FOOTER //
// ./src/shared/utils/index.js